import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconMenu.tsx
const OutlinedFilledMenu = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-203v-95h771v95H95Zm0-230v-94h771v94H95Zm0-229v-95h771v95H95Z" })
});
const OutlinedMenu = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-203v-95h771v95H95Zm0-230v-94h771v94H95Zm0-229v-95h771v95H95Z" })
});
const RoundedFilledMenu = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M142-203q-19.75 0-33.37-13.68Q95-230.35 95-251.18q0-19.82 13.63-33.32Q122.25-298 142-298h676q19.75 0 33.88 13.68Q866-270.65 866-250.82q0 20.82-14.12 34.32Q837.75-203 818-203H142Zm0-230q-19.75 0-33.37-13.68Q95-460.35 95-480.18q0-19.82 13.63-33.32Q122.25-527 142-527h676q19.75 0 33.88 13.68Q866-499.65 866-479.82q0 19.82-14.12 33.32Q837.75-433 818-433H142Zm0-229q-19.75 0-33.37-13.68Q95-689.35 95-710.18q0-19.82 13.63-33.32Q122.25-757 142-757h676q19.75 0 33.88 13.68Q866-729.65 866-709.82q0 20.82-14.12 34.32Q837.75-662 818-662H142Z" })
});
const RoundedMenu = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M142-203q-19.75 0-33.37-13.68Q95-230.35 95-251.18q0-19.82 13.63-33.32Q122.25-298 142-298h676q19.75 0 33.88 13.68Q866-270.65 866-250.82q0 20.82-14.12 34.32Q837.75-203 818-203H142Zm0-230q-19.75 0-33.37-13.68Q95-460.35 95-480.18q0-19.82 13.63-33.32Q122.25-527 142-527h676q19.75 0 33.88 13.68Q866-499.65 866-479.82q0 19.82-14.12 33.32Q837.75-433 818-433H142Zm0-229q-19.75 0-33.37-13.68Q95-689.35 95-710.18q0-19.82 13.63-33.32Q122.25-757 142-757h676q19.75 0 33.88 13.68Q866-729.65 866-709.82q0 20.82-14.12 34.32Q837.75-662 818-662H142Z" })
});
const SharpFilledMenu = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-203v-95h771v95H95Zm0-230v-94h771v94H95Zm0-229v-95h771v95H95Z" })
});
const SharpMenu = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-203v-95h771v95H95Zm0-230v-94h771v94H95Zm0-229v-95h771v95H95Z" })
});
const componentMap = {
	outlined: OutlinedMenu,
	"outlined-fill": OutlinedFilledMenu,
	rounded: RoundedMenu,
	"rounded-fill": RoundedFilledMenu,
	sharp: SharpMenu,
	"sharp-fill": SharpFilledMenu
};
const IconMenu = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconMenu };